import React from 'react';
import { formatPrice } from 'utils/formating';
import { VatDisplay } from 'subscriptionOptions/vatDisplay';

type PaymentVatRowProps = {
  mode: VatDisplay;
  vatRate: number;
  vat: number;
};

export const PaymentVatRow: React.FC<PaymentVatRowProps> = ({ mode, vatRate, vat }) => (
  <div className="DetailsItem">
    <p>{mode === 'reverseCharge' ? 'VAT*' : mode === 'notApplicable' ? 'VAT' : `VAT (${vatRate}%)`}</p>
    <span>{mode === 'notApplicable' ? 'Not applicable' : `£ ${formatPrice(vat)}`}</span>
  </div>
);
